import { FC, useState } from 'react';
import { CardBody, CardTitle, CardTitleRow, OutlinedCard, SourceChip } from '../CompanyOverview.styles';
import CapIQKeyDevelopmentsCard from './CapIQKeyDevelopmentsCard';
import { NewsAndPressReleasesCardProps, Tab } from './NewsAndPressReleasesCard.props';
import { TabButton, TabRow } from './NewsAndPressReleasesCard.styles';
import SacraPressReleasesCard from './SacraPressReleasesCard';

const NewsAndPressReleasesCard: FC<NewsAndPressReleasesCardProps> = ({ companyId }) => {
  const [activeTab, setActiveTab] = useState<Tab>('sacra');

  return (
    <OutlinedCard variant="outlined">
      <CardBody>
        <CardTitleRow>
          <CardTitle>News &amp; Press Releases</CardTitle>
          {activeTab === 'sacra' && <SourceChip label="Sacra" size="small" chipColor="blue" />}
          {activeTab === 'capiq' && <SourceChip label="Cap IQ" size="small" chipColor="blue" />}
        </CardTitleRow>

        <TabRow>
          <TabButton active={activeTab === 'sacra'} onClick={() => setActiveTab('sacra')}>
            Sacra
          </TabButton>
          <TabButton active={activeTab === 'capiq'} onClick={() => setActiveTab('capiq')}>
            Cap IQ Key Developments
          </TabButton>
        </TabRow>

        {activeTab === 'sacra' && <SacraPressReleasesCard companyId={companyId} />}
        {activeTab === 'capiq' && <CapIQKeyDevelopmentsCard companyId={companyId} />}
      </CardBody>
    </OutlinedCard>
  );
};

export { NewsAndPressReleasesCard };
